export enum ErrorMessages {
  FETCH_DATA_ERROR = 'Error fetching data',
  SAVE_DATA_ERROR = 'Error saving data',
}
